import { CheckCircle2, ArrowUpRight, AlertTriangle } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

// Converts a reading to mg/dL for comparison against the target band.
function toMgdl(value, unit) {
  return unit === "mmol/L" ? value * 18 : value;
}

export function classifyGlucose(value, unit, target) {
  if (!target) return null;
  const v = toMgdl(value, unit);
  const lo = toMgdl(target.lower, target.unit);
  const hi = toMgdl(target.upper, target.unit);
  if (v < lo) return "below";
  if (v > hi) return "above";
  return "in";
}

export default function StatusBadge({ status }) {
  const { t } = useI18n();
  if (!status) return null;
  const map = {
    in: { bg: "#E6F4EA", border: "#A8DADC", text: "#137333", Icon: CheckCircle2, label: t("st_in") },
    above: { bg: "#FEF7E0", border: "#FDE293", text: "#B06000", Icon: ArrowUpRight, label: t("st_above") },
    below: { bg: "#FCE8E6", border: "#FAD2CF", text: "#C5221F", Icon: AlertTriangle, label: t("st_below") },
  };
  const s = map[status];
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold"
      style={{ background: s.bg, border: `1px solid ${s.border}`, color: s.text }}
      data-testid={`status-badge-${status}`}
    >
      <s.Icon size={13} strokeWidth={2.5} aria-hidden="true" />
      {s.label}
    </span>
  );
}
